export function moveLabelFocus(from: HTMLInputElement, step: 1 | -1): boolean {
  const labels = Array.from(
    document.querySelectorAll<HTMLInputElement>("[data-leaf-label]"),
  );
  const target = labels[labels.indexOf(from) + step];
  target?.focus();
  return target !== undefined;
}
